export default {
  sentiment: 'Sentimiento',
  medias: 'Medios',
  news: 'Portales',
  quotes: 'Citas',
  valoration: 'Eq. publicitaria',
  centage: 'Centimetraje',
  minute: 'Minutos',
};
